var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    'festival-year__banner',
    { 'festival-year__banner--short': !_vm.isFestivalYearHomepage } ],style:({ backgroundImage: ("url(" + _vm.festivalYearBanner + ")") })})}
var staticRenderFns = []

export { render, staticRenderFns }